export const REMOTE_DOORMAN_SETTINGS = 'RemoteDoormanSettings';

export const SYNC_ACCOUNT_TYPE = {
  bmx: 'bmx',
  brivo: 'brivo',
  comelit: 'comelit',
  dormakaba: 'dormakaba',
  salto: 'salto',
  smartair: 'smartair',
  twoN: '2n',
  lyazon: 'lyazon',
  zerv: 'zerv',
  keyscan: 'keyscan',
};

export const CARDS_TARGET_IDS = {
  propertySettings: 'property-settings',
  generalSettings: 'general-settings',
  remoteDoorman: 'remote-doorman',
  leasing: 'leasing',
  integrationsStatus: 'integrations-status',
  accessControlAccount: 'access-control-accounts',
  accountingAccount: 'accounting-accounts',
  cameraAccount: 'cameras-accounts',
  paymentAccount: 'payments-accounts',
  deliveryTypes: 'delivery-types',
  visitorSettings: 'visitor-settings',
  amenityReservationSettings: 'amenity-reservation-settings',
  serviceRequestCategoriesSettings: 'service-request-categories-settings',
  customLinks: 'custom-links',
};
